import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase/config';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';

function Navbar({ coachName }) {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (err) {
      console.error('Error signing out:', err);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-brand">
          <svg width="32" height="32" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="8" y="29" width="26" height="4" rx="2" fill="#2ECC71"/>
            <rect x="66" y="29" width="26" height="4" rx="2" fill="#2ECC71"/>
            <rect x="8" y="48" width="26" height="5" rx="2.5" fill="#2ECC71"/>
            <rect x="66" y="48" width="26" height="5" rx="2.5" fill="#2ECC71"/>
            <rect x="8" y="68" width="26" height="4" rx="2" fill="#2ECC71"/>
            <rect x="66" y="68" width="26" height="4" rx="2" fill="#2ECC71"/>
            <circle cx="50" cy="50" r="17" fill="none" stroke="#ffffff" strokeWidth="3.5"/>
          </svg>
          <span className="navbar-title">Coach Connect</span>
        </div>

        <div className="navbar-right">
          <span className="navbar-coach-name">{coachName}</span>
          <button onClick={handleSignOut} className="signout-button">
            Sign Out
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
